import { ResourcefulResponseFormat } from '../types'
import type { HttpContext } from '@adonisjs/core/http'

export const negotiateContent = (ctx: HttpContext): ResourcefulResponseFormat => {
  for (const acceptable of ResourcefulResponseFormat) {
    if (
      ctx.request.header('accept')?.includes(acceptable) &&
      !ctx.request.header('accept')?.includes('json')
    ) {
      return acceptable
    }
  }
  return 'json'
}

export const getPossibleHttpErrorCodes = () => {
  const errorCodes: Set<number> = new Set()
  const queue = [
    [400, 429],
    431,
    444,
    450,
    451,
    [495, 504],
    [506, 511],
    521,
    522,
    523,
    525,
    530,
    599,
  ]
  queue.forEach((item) => {
    if (Array.isArray(item)) {
      for (let i = item[0]; i <= item[1]; i++) {
        errorCodes.add(i)
      }
    } else {
      errorCodes.add(item)
    }
  })
  return Array.from(errorCodes).sort((a, b) => a - b)
}

export const describeHttpError = (code: number): string => {
  const map: Record<number, string> = {
    400: 'Bad Request',
    401: 'Unauthorized',
    402: 'Payment Required',
    403: 'Forbidden',
    404: 'Not Found',
    405: 'Method Not Allowed',
    406: 'Not Acceptable',
    407: 'Proxy Authentication Required',
    408: 'Request Timeout',
    409: 'Conflict',
    410: 'Gone',
    411: 'Length Required',
    412: 'Precondition Failed',
    413: 'Payload Too Large',
    414: 'URI Too Long',
    415: 'Unsupported Media Type',
    416: 'Range Not Satisfiable',
    417: 'Expectation Failed',
    418: "I'm a teapot",
    420: 'Enhance Your Calm',
    421: 'Misdirected Request',
    422: 'Unprocessable Entity',
    423: 'Locked',
    424: 'Failed Dependency',
    425: 'Too Early',
    426: 'Upgrade Required',
    428: 'Precondition Required',
    429: 'Too Many Requests',
    431: 'Request Header Fields Too Large',
    444: 'No Response',
    450: 'Blocked by Windows Parental Controls',
    451: 'Unavailable For Legal Reasons',
    497: 'HTTP Request Sent to HTTPS Port',
    498: 'Invalid Token',
    499: 'Client Closed Request',
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    504: 'Gateway Timeout',
    506: 'Variant Also Negotiates',
    507: 'Insufficient Storage',
    508: 'Loop Detected',
    509: 'Bandwidth Limit Exceeded',
    510: 'Not Extended',
    511: 'Network Authentication Required',
    521: 'Web Server Is Down',
    522: 'Connection Timed Out',
    523: 'Origin Is Unreachable',
    524: 'A Timeout Occurred',
    525: 'SSL Handshake Failed',
    526: 'Invalid SSL Certificate',
    527: 'Railgun Error',
    530: 'Site is Frozen',
    599: 'Network Connect Timeout Error',
  }
  if (map[code]) return map[code]
  if (code >= 400 && code < 500) return map[400]
  if (code >= 500 && code < 600) return map[500]
  return 'Unknown Error'
}
